module.exports = __webpack_public_path__ + "media/new_images/powered-by-google-aab93790.png";